"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyStateBasePage = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@alcumus/components");
const core_1 = require("@material-ui/core");
const useStyles = (0, core_1.makeStyles)(() => ({
    body: {
        fontWeight: components_1.StyleVariables.fonts.weight.semiBold,
        color: components_1.StyleVariables.colors.grey5,
        lineHeight: components_1.StyleVariables.fonts.lineHeight.regular,
        marginBottom: 40,
        whiteSpace: 'pre-line',
    },
    image: {
        width: 232,
        margin: '72px 0 40px 0',
    },
}));
const EmptyStateBasePage = ({ body, imgSrc, children, }) => {
    const classes = useStyles();
    return (react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "column", alignItems: "center" },
        react_1.default.createElement(components_1.Image, { src: imgSrc, className: classes.image, "data-testid": "img", alt: imgSrc }),
        react_1.default.createElement(components_1.Text, { as: "h5", center: true, "data-testid": "body", className: classes.body }, body),
        children));
};
exports.EmptyStateBasePage = EmptyStateBasePage;
